import { useQuizQuestionsDragNDropStore } from "@/store/quiz-question-drag";
import { useQuizQuestionsGapStore } from "@/store/quiz-question-gap";
import { VueRenderer } from "@tiptap/vue-3";
import tippy from "tippy.js";
import MentionList from "./MentionList.vue";

const questionStores = {
  dragAndDrop: useQuizQuestionsDragNDropStore,
  gap: useQuizQuestionsGapStore,
};

export const createSuggestion = (questionStoreType: "dragAndDrop" | "gap") => {
  return {
    items: ({ query, editor }) => {
      const editorHTML = editor.getHTML();
      const getExistingMentionsFromHTML = () => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(editorHTML, "text/html");
        const mentions = new Set<string>();

        doc.querySelectorAll("span.mention[data-label]").forEach((mention) => {
          const mentionId = mention.getAttribute("data-label");
          if (mentionId) mentions.add(mentionId);
        });
        return mentions;
      };

      const existingMentions = getExistingMentionsFromHTML();

      // const suggestions = useQuizQuestionsDragNDropStore.gaps;
      const store = questionStores[questionStoreType]; 
      const suggestions = store.gaps; 

      const filteredSuggestions = suggestions.filter(
        (item) =>
          !existingMentions.has(String(item?.name)) &&
          item?.name.toLowerCase().includes(query.toLowerCase())
      );
      return filteredSuggestions;
    },

    render: () => {
      let component;
      let popup;

      return {
        onStart: (props) => {
          if (!props.clientRect) {
            return;
          }

          component = new VueRenderer(MentionList, {
            props,
            editor: props.editor,
          });

          popup = tippy("body", {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
          });
        },

        onUpdate(props) {
          component.updateProps(props);

          if (!props.clientRect) {
            return;
          }
          popup[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props) {
          if (props.event.key === "Escape") {
            popup[0].hide();
            return true;
          }

          return component.ref?.onKeyDown(props);
        },

        onExit() {
          popup[0].destroy();
          component.destroy();
        },
      };
    },

    command: ({ editor, range, props }) => {
      editor
        .chain()
        .focus()
        .deleteSelection()
        .insertContentAt(range, [
          {
            type: "mention",
            attrs: { label: props?.name.trim(), id: props?.id },
          },
        ])
        .run();
    },
  };
};
